/* tslint:disable */
import {
  Institutions,
  AnnualBreakdown,
  FundsAccount
} from '../index';

declare var Object: any;
export interface FundsAllocatedInterface {
  "financial_year": string;
  "actual_amount": number;
  "date_disbursed": Date;
  "disbursement_number": number;
  "institution_id": number;
  "id"?: number;
  "annual_breakdown_id"?: number;
  "funds_account_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  institutions?: Institutions;
  annualBreakdown?: AnnualBreakdown;
  fundsAccount?: FundsAccount;
}

export class FundsAllocated implements FundsAllocatedInterface {
  "financial_year": string;
  "actual_amount": number;
  "date_disbursed": Date;
  "disbursement_number": number;
  "institution_id": number;
  "id": number;
  "annual_breakdown_id": number;
  "funds_account_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  institutions: Institutions;
  annualBreakdown: AnnualBreakdown;
  fundsAccount: FundsAccount;
  constructor(data?: FundsAllocatedInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FundsAllocated`.
   */
  public static getModelName() {
    return "FundsAllocated";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FundsAllocated for dynamic purposes.
  **/
  public static factory(data: FundsAllocatedInterface): FundsAllocated{
    return new FundsAllocated(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FundsAllocated',
      plural: 'FundsAllocateds',
      path: 'FundsAllocateds',
      properties: {
        "financial_year": {
          name: 'financial_year',
          type: 'string'
        },
        "actual_amount": {
          name: 'actual_amount',
          type: 'number'
        },
        "date_disbursed": {
          name: 'date_disbursed',
          type: 'Date'
        },
        "disbursement_number": {
          name: 'disbursement_number',
          type: 'number'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "annual_breakdown_id": {
          name: 'annual_breakdown_id',
          type: 'number'
        },
        "funds_account_id": {
          name: 'funds_account_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        institutions: {
          name: 'institutions',
          type: 'Institutions',
          model: 'Institutions'
        },
        annualBreakdown: {
          name: 'annualBreakdown',
          type: 'AnnualBreakdown',
          model: 'AnnualBreakdown'
        },
        fundsAccount: {
          name: 'fundsAccount',
          type: 'FundsAccount',
          model: 'FundsAccount'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/FundsAllocated.ts